import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  DealerSaleItemEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiDealerSaleDetail = (
    dealerSaleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      dealerSaleId = unref(dealerSaleId);
      
      return fetchApiInstance<DealerSaleItemEntity>(
      {url: `/dealerSales/${dealerSaleId}/detail`, method: 'GET'
    },
      options);
    }
  

export const getApiDealerSaleDetailQueryKey = (dealerSaleId: MaybeRef<string | undefined | null>,) => {
    return ['dealerSales',dealerSaleId,'detail'] as const;
    }

    
export const getApiDealerSaleDetailQueryOptions = <TData = Awaited<ReturnType<typeof apiDealerSaleDetail>>, TError = ErrorType<BackendErrorEntity>>(dealerSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDealerSaleDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiDealerSaleDetailQueryKey(dealerSaleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealerSaleDetail>>> = () => apiDealerSaleDetail(dealerSaleId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(dealerSaleId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealerSaleDetail>>, TError, TData> 
}

export type ApiDealerSaleDetailQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealerSaleDetail>>>
export type ApiDealerSaleDetailQueryError = ErrorType<BackendErrorEntity>



export function useApiDealerSaleDetail<TData = Awaited<ReturnType<typeof apiDealerSaleDetail>>, TError = ErrorType<BackendErrorEntity>>(
 dealerSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDealerSaleDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiDealerSaleDetailQueryOptions(dealerSaleId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



